import { render, staticRenderFns } from "./OrgIndex.vue?vue&type=template&id=10ae30f0&scoped=true"
import script from "./OrgIndex.vue?vue&type=script&lang=js"
export * from "./OrgIndex.vue?vue&type=script&lang=js"
import style0 from "./OrgIndex.vue?vue&type=style&index=0&id=10ae30f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10ae30f0",
  null
  
)

export default component.exports